module.exports = "<p>\n  role works!\n</p>\n"